/**
 * @component {"type":"SecondColumnContent","version":"1.0"}
 * @component {"type":"UITexts","version":"1.0"}
 * @component {"type":"CustomUITexts","version":"1.0"}
 * @component {"type":"ShortTexts","version":"1.0"}
 * @component {"type":"TextMatrices","version":"1.0"}
 * @component {"type":"FormattedTexts","version":"1.0"}

 * @component {"type":"Feedbacks","version":"1.0"}
 * @component {"type":"CustomModals","version":"1.0"}
 * @component {"type":"EvaluateTask","version":"1.0"}
 */

define('trainingVM',['jquery', 'knockout', 'knockout-mapping', 'helpers', 'utils', 'training', 'user-answers', 'feedback', 'modal', 'dialog-manager', 'current-user-answer', 'pagination', 'comment-tool', 'navigation', 'lodash', 'dropkick', 'nouislider'],
    function($, ko, mapping, helpers, utils, Training, UserAnswers, Feedback, Modal, Dialog, CurrentUserAnswer, Pagination, commentTool, Navigation) {
        'use strict';

        return function(viewModel, dataContext) {
            var self                = this,
                data                = dataContext.learning,
                user                = null,
                userVM              = viewModel.user,
                entityVM            = viewModel.entity,
                lang                = null,
                modal               = null,
                computedQuizMap     = [],
                currentUserAnswer   = null,
                timeoutID; // used for forward

            if (!data || !data.current) {
                return;
            }

            self.dataContext = dataContext;

            self.course = {};

            user        = data.user;
            lang        = data.lang;

            var navigation = new Navigation(),
                training = new Training(),
                feedback = new Feedback(),
                dialog = new Dialog(),
                userAnswers = new UserAnswers();

            /* TrainingVM properties */
            self.componentsJSON = ko.computed(function() {
                var componentsJson = data.training.componentsJson;
                return (componentsJson) ? JSON.parse(componentsJson) : [];
            });

            self.contentContainerID = ko.observable(data.training.contentContainerId);

            self.description = ko.computed(function() {
                return (data.training.description) ? data.training.description.trim() : '';
            });

            self.enforceSequence = ko.observable(data.training.enforceSequence);
            self.imagePosition = ko.observable(data.training.imagePosition);
            self.imageScaleMode = ko.observable(data.training.imageScaleMode);
            self.trainingContentEntities = ko.observable(data.training.contentEntities);
            self.alternativeNavigation = ko.observable(false);
            self.notificationItems = ko.observableArray();
            self.savedAnswers = ko.observable('none');
            self.showUnlockButton = ko.observable(false);

            /* END TrainingVM properties */

            /* TrainingVM methods */
            self.getEntity = function(ID) {
                return training.getEntity(ID);
            }

            self.getMediaURL = function(imageID) {
                return training.getMediaURL(imageID);
            }

            self.parseMediaURL = function(imageURL) {
                return training.parseMediaURL(imageURL);
            }
            /* END TrainingVM methods */

            /* Compatibility */

            self.name = entityVM.name;
            self.title = entityVM.title;
            self.entityTitle = entityVM.pageTitle;
            self.parentId = entityVM.parentId;
            self.entityParents  = entityVM.parents;
            self.content = entityVM.content;
            self.text = entityVM.text;
            self.ID = entityVM.ID;
            self.contentEntityId = entityVM.ID;
            self.defaultNaviTargetId = entityVM.naviTargetId;
            self.naviTargetId = entityVM.naviTargetId;
            self.typeId = entityVM.typeId;
            self.displayMode = entityVM.displayMode;
            self.freeTextAnswerId = entityVM.freeTextAnswerId;
            self.showDontKnowOption = entityVM.showDontKnowOption;
            self.leftColumnTitle = entityVM.leftColumnTitle;
            self.rightColumnTitle = entityVM.rightColumnTitle;
            self.passAlways = entityVM.passAlways;
            self.passThreshold = entityVM.passThreshold;
            self.passedFeedback = entityVM.passedFeedback;
            self.failedFeedback = entityVM.failedFeedback;
            self.enableMovingBackwards = entityVM.enableMovingBackwards;
            self.completeDespiteResults = entityVM.completeDespiteResults;
            self.requiresCompletion = entityVM.requiresCompletion;
            self.taskCountToAsk = entityVM.taskCountToAsk;
            self.taskCountToShow = entityVM.taskCountToShow;
            self.canSubmitMultipleTimes = entityVM.canSubmitMultipleTimes;
            self.requiresAnswer = entityVM.requiresAnswer;
            self.hasCorrectAnswers = entityVM.hasCorrectAnswers;
            self.correctAnswerFeedbackId = entityVM.correctAnswerFeedbackId;
            self.incorrectAnswerFeedbackId = entityVM.incorrectAnswerFeedbackId;
            self.answerScoreCaption = entityVM.answerScoreCaption;
            self.answerNoOpinionCaption = entityVM.answerNoOpinionCaption;
            self.answers = entityVM.answers;
            self.questions = entityVM.questions;
            self.childrens = entityVM.childrens;
            self.componentsJson = entityVM.componentsJson;
            self.components = entityVM.components;

            self.isQuizPage = entityVM.isQuizPage;
            self.isQuizTask = entityVM.isQuizTask;
            /* END Compatibility */


            // These are used in pagination but could be removed and use training module's modularMenuPageID
            self.returnFromSections = false;
            self.returnFromSectionsId;

            self.lang           = ko.observable(lang);

            self.allowKeyboardShorts = ko.observable(true);

            self.isTaskAnswered = ko.observable(false);

            self.contentText    = ko.computed(function() {
                var val = self.content() || self.text();
                return helpers.misc.replaceTextholder(viewModel, data, val);
            });

            self.allAnswersRequired     = ko.observable(true);
            self.quizRestarting         = ko.observable(false);

            self.showCorrectAnswers     = ko.observable(false);
            self.answersEnabled         = ko.observable(true);

            self.isValid                = ko.observable(false);

            self.showRestartQuizButton  = ko.observable(false);

            self.course.componentsJson = ko.observable(data.training.componentsJson);
            self.course.components = ko.observable(helpers.content.convertComponents(JSON.parse(self.course.componentsJson())));

            self.updateTraining = function(trainingData){
                this.training = trainingData;
                self.trainingContentEntities(trainingData.contentEntities);

                // Remove old structure and add new
                self.trainingMap.removeAll();
                ko.utils.arrayPushAll(self.trainingMap, helpers.content.getTrainingMap(trainingData.contentEntities));

                // Update page count
                self.total(self.trainingMap().length);

                // dataContext.updateVM(entityVM.ID());
            };

            self.trainingMap = ko.observableArray(helpers.content.getTrainingMap(self.trainingContentEntities()));

            self.getComponents = function(self){
                return helpers.content.componentObject.getComponents(self);
            };

            self.getComponentsOfPageByKind = function(page, kind) {
                return helpers.content.componentObject.getComponentsOfPageByKind(page, kind);
            };

            // Search components by kind from page and course
            self.getComponentsByKind = function(kind) {
                return entityVM.getComponentsByKind(kind).concat(helpers.content.componentObject.getComponentsByKind(self.course, kind));
            };

            // Search param by name from all page's components
            self.getComponentParamValuesByName = function(name) {
                return helpers.content.componentObject.getComponentParamValuesByName(self, name);
            };

            if (training.scormPackage) {
                require(['scormPackage'], function(ScormPackage) {
                    var scormPackage = new ScormPackage();

                    scormPackage.update(self.trainingMap(), training, userVM);
                });
            }

            self.getTasksAndAnswers = function() {
                var tasksAndAnswers = [],
                    tasks = helpers.content.getTaskEntities(data);

                if(tasks.length > 0){
                    tasks.forEach(function(task){
                        var answer = helpers.User.getAnswer(user, task.contentEntityId),
                            taskAndAnswer = {};

                        taskAndAnswer.title = task.contentEntity.name;
                        taskAndAnswer.typeId = task.typeId;
                        taskAndAnswer.contentEntityId = task.contentEntityId;

                        taskAndAnswer.componentsKinds = [];
                        if(task.contentEntity.components && task.contentEntity.components.length > 0) {
                            task.contentEntity.components.forEach(function(component){
                                taskAndAnswer.componentsKinds.push(component.kind);
                            });
                        }

                        switch(task.typeId){
                            case 12:    // Open question
                                taskAndAnswer.question = ((task.questions[0].text.length > 1)) ? task.questions[0].text: '';
                                var options = task.answers;
                                taskAndAnswer.options = [];
                                if(options.length > 0) {
                                    options.forEach(function (option) {
                                        if (answer.answers.length > 0) {
                                            answer.answers.forEach(function (answer) {
                                                if (option.id === answer.answerId) {
                                                    if (answer.answerText) {
                                                        taskAndAnswer.options.push({
                                                            text: option.text,
                                                            answerText: answer.answerText
                                                        });
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }else if(answer.answers.length > 0) {
                                    // only one question
                                    taskAndAnswer.options.push({
                                        answerText: answer.answers[0].answerText
                                    });
                                }
                                break;

                            case 13:    // Multiple question

                                var questions = task.questions,
                                    contentEntity = helpers.content.getEntity(task.contentEntityId, data.training.contentEntities).contentEntity,
                                    freeTextAnswerId = contentEntity.freeTextAnswerId;

                                taskAndAnswer.question = ((questions[0].text.length > 1)) ? questions[0].text: '';

                                var options = task.answers;

                                taskAndAnswer.options = [];
                                if (answer.answers.length > 0) {
                                    answer.answers.forEach(function (answer) {
                                        var option = _.findWhere(options, {'id': answer.answerId });
                                        var answer = (freeTextAnswerId == answer.answerId) ? answer.answerText: option.text;
                                        if (answer) {
                                            taskAndAnswer.options.push({
                                                answerText: answer
                                            });
                                        }
                                    });
                                }
                                break;

                            case 17:    // Evaluate
                                var questions = task.questions;
                                var options = task.answers;

                                taskAndAnswer.options = [];

                                if(questions.length > 0) {
                                    questions.forEach(function (question) {
                                        if (answer.answers.length > 0) {
                                            var userAnswer = _.findWhere(answer.answers, { 'questionId': question.id });
                                            var option = _.findWhere(options, {'id': userAnswer.answerId });
                                            taskAndAnswer.options.push({
                                                text: question.text,
                                                answerText: (option && option.text) ? option.text : ''
                                            });
                                        }
                                    });
                                }
                                break;

                            default:
                                if (dataContext.debugMode) {
                                    console.warn("Adding answer for type "+ task.typeId +" has not been implemented");
                                }
                                break;
                        }
                        tasksAndAnswers.push(taskAndAnswer);
                    });
                }

                return  tasksAndAnswers;
            };

            self.isTask = ko.computed(function() {
                return entityVM.isTaskPage();
            });

            self.quizMap = ko.computed(function() {
                var ID = entityVM.ID(),
                    i = 0,
                    obj = null,
                    entity = null,
                    answers = null,
                    previousComputedQuizMap = [],
                    previousMap = function(entity, answers) {
                        var child,
                            children = entity.children,
                            i = 0,
                            len = children.length,
                            j = 0,
                            arr = [],
                            taskCount = entity.contentEntity.taskCountToShow;

                        for( ; i<len; i++) {
                            child = children[i];
                            j = answers.length;
                            while(j--) {
                                if (answers[j].contentEntityId && child.contentEntityId === answers[j].contentEntityId && answers[j].answers && Array.isArray(answers[j].answers) && answers[j].answers.length) {
                                    arr.push(child.contentEntityId);
                                }
                            }
                        }

                        return (taskCount && arr.length > taskCount) ? arr.splice(0, taskCount) : arr;
                    };

                if (self.isQuizPage() && !self.isQuizTask()) {
                    answers = user.answers;
                    i = answers.length;

                    while(i--) {
                        if (answers[i].contentEntityId === ID) {
                            obj = answers[i];
                            break;
                        }
                    }

                    if (obj) {
                        entity = training.getEntity(ID);

                        if (entity !== null) {

                            if (obj.computedQuizMap && obj.computedQuizMap.length && !self.quizRestarting()) {
                                computedQuizMap = obj.computedQuizMap.slice(0);

                            } else {

                                if (!self.quizRestarting()) {
                                    previousComputedQuizMap = previousMap(entity, user.answers);
                                }

                                self.quizRestarting(false);

                                computedQuizMap = (!previousComputedQuizMap.length) ? helpers.content.getQuizMap(entity.children) : previousComputedQuizMap.slice(0);

                                if (!previousComputedQuizMap.length && !!entity.contentEntity.shuffleTasks && Array.isArray(computedQuizMap)) {
                                    computedQuizMap.shuffle();
                                }

                                if (computedQuizMap) {
                                    obj.computedQuizMap = computedQuizMap.slice(0);
                                }
                            }
                        }
                    }

                    if (self.taskCountToShow() && self.taskCountToShow() < computedQuizMap.length) {
                        computedQuizMap = computedQuizMap.splice(0, self.taskCountToShow());
                    }
                }

                return computedQuizMap;

            });

            self.resetQuizProgress = ko.computed(function() {
                var ID = '',
                    answers = user.answers,
                    counter = 0,
                    entity = training.getEntity(entityVM.ID()),
                    childrens = entity.children,
                    taskCountToShow = self.taskCountToShow(),
                    i = childrens.length,
                    j = 0;

                while(i--) {
                    ID = childrens[i].contentEntityId;
                    j = answers.length;
                    while(j--) {
                        if (answers[j].contentEntityId === ID && answers[j].answers.length) {
                            counter++;
                        }
                    }
                }

                if (taskCountToShow && taskCountToShow === counter || childrens.length === counter) {
                    // return true;
                } else if (self.isQuizPage() && !self.isQuizTask() && !currentUserAnswer) {
                    currentUserAnswer = new CurrentUserAnswer(user.answers, ID);
                    self.quizRestarting(true);
                }
            }).extend({rateLimit: 0});

            self.updateVisited = function(ID, entity) {
                var uninteracted = document.querySelectorAll('[data-interacted="false"]').length || 0;

                ID = ID || entityVM.ID()
                entity = entity || training.getEntity(ID);

                if (uninteracted === 0) {

                    if (!training.scormPackage || !helpers.entity.isTaskPage(entity)) {
                        userAnswers.logVisited(ID);
                        dataContext.logProgress('visited', ID);
                    }

                    if (training.scormPackage) {
                        require(['scormPackage'], function(ScormPackage) {
                            var scormPackage = new ScormPackage();

                            scormPackage.setLocation(ID);

                            scormPackage.setSuspend(userAnswers);

                            scormPackage.setEntity(ID);
                            scormPackage.setQuizMap(computedQuizMap);

                            if (scormPackage.entityIsPage()) {
                                scormPackage.setLessonStatus(userAnswers);
                            }
                        });
                    }
                }
            };

            ko.bindingHandlers.updateVisited = {
                init: function() {
                    self.entityChanged = ko.computed(function() {
                        var content = entityVM.entityContent(),
                            ID = content.ID,
                            entity = training.getEntity(ID);

                        if (ID && !helpers.entity.isQuizPage(entity)) {
                            self.updateVisited(ID, entity);
                        } else if (training.scormPackage) {
                            require(['scormPackage'], function(ScormPackage) {
                                var scormPackage = new ScormPackage();

                                scormPackage.setLocation(ID);
                                scormPackage.setSuspend(userAnswers);
                            });
                        }

                        navigation.completeLoading();

                        training.setState('');

                        if (dataContext.debugMode) {
                            console.log('5. updateVisited');
                            console.log('---------  updateVM total: ' + (new Date() - window.initPageRender) + '  ---------');
                        }
                    }).extend({rateLimit: 0});
                },
                after: ['customJS']
            };

            function openFeedback(ID) {
                dialog.open({
                    type: 'feedback',
                    content: feedback.getContent(ID)
                });
            }

            ko.computed(function() {
                var ID = entityVM.ID(),
                    entity = training.getContent(ID),
                    content = training.getComponent('TaskSettings', ID);

                document.body.classList.remove('nav-menu-open');

                self.isTaskAnswered(false);
                self.isValid(false);

                if (timeoutID) {
                    clearTimeout(timeoutID);
                }

                dialog.close({
                    type: ['dialog', 'modal', 'feedback']
                });

                if (entity.typeID === 19) {
                    var progress = userAnswers.getQuizPageProgress(ID);

                    if (progress && (progress.isAnswered && progress.isPassed || progress.isVisited)) {

                        userAnswers.logVisited(ID);

                        dataContext.logProgress('visited', ID);

                        userAnswers.addAnswer(ID, {
                            answered: true,
                            score: progress.userScore,
                            passed: progress.isPassed
                        });
                    }
                }

                currentUserAnswer = new CurrentUserAnswer(user.answers, ID);

                if (!userAnswers.isTaskPageAnswered(ID) || training.state === 'reload' || training.state === 'reset' || entity.typeID === 19) {
                    self.savedAnswers((training.state === 'reload') ? 'hide' : 'none'); // maybe hide when reload???
                    self.answersEnabled(true);
                    self.showUnlockButton(false);
                    self.showCorrectAnswers(false);
                    return;
                }

                if (!entity.canSubmitMultipleTimes) {
                    self.savedAnswers('none');
                    self.answersEnabled(false);
                    self.showUnlockButton(false);
                    self.showCorrectAnswers(false);

                    setTimeout(function() {
                        if (feedback.contains(entity)) {
                            openFeedback(ID);
                        }
                    }, 0);

                    return;
                }

                if (!Object.keys(content).length || content.resetButton) {
                    self.answersEnabled(false);
                    self.showUnlockButton(true);
                    if (entity.hasCorrectAnswers) {
                        self.showCorrectAnswers(true);
                    }
                } else {
                    self.answersEnabled(true);
                    self.showUnlockButton(false);
                    self.showCorrectAnswers(false);
                }

                if (Object.keys(content).length) {
                    if (content.showSavedAnswers) {
                        self.savedAnswers('show');
                    } else if (content.showSavedAnswers === false) {
                        self.savedAnswers('hide');
                    } else {
                        self.savedAnswers('none');
                    }
                }
            });

            self.computedAnswers = ko.computed(function() {
                var ID = entityVM.ID(),
                    entity = training.getEntity(ID);

                if (!Array.isArray(entity.answers) || !entity.answers.length) {
                    return [];
                }

                if (entity.contentEntity.shuffleOptions && training.state !== 'reset' && self.answersEnabled() && (entity.contentEntity.canSubmitMultipleTimes || !userAnswers.isTaskPageAnswered(ID))) {
                    entity.answers.shuffle();
                }

                return entity.answers;
            }).extend({deferred: true});

            self.computedQuestions = ko.computed(function() {
                var ID = entityVM.ID(),
                    entity = training.getEntity(ID),
                    questions = Array.isArray(entity.questions) ? entity.questions : [];

                if (!questions.length || entity.typeId !== 15 || training.state === 'reset' || !entity.contentEntity.shuffleOptions) {
                    return questions;
                }

                if (self.answersEnabled() && training.state !== 'reset' && (entity.contentEntity.canSubmitMultipleTimes || !userAnswers.isTaskPageAnswered(ID)) && (entity.typeId !== 15 || training.state !== 'init')) {
                    questions.shuffle();
                }

                return questions;
            }).extend({deferred: true});

            self.sliderAnswers = ko.computed(function() {
                var ID = entityVM.ID(),
                    entity = training.getEntity(ID),
                    answers = (entity && Array.isArray(entity.answers)) ? entity.answers.slice(0) : [];

                return answers.sort(function(a, b) {
                    if (a.orderNum < b.orderNum) {
                        return -1;
                    } else if(b.orderNum < a.orderNum) {
                        return 1;
                    }
                    return 0;
                }).filter(function(answer) {
                    return (answer.text !== '-');
                }).map(function(answer) {
                    return answer.text;
                });
            });

            self.showActionButtons = ko.computed(function() {
                var entity = training.getContent(entityVM.ID()),
                    content;

                switch(entity.typeID) {
                case 10: // Content Page
                    return false;
                case 13:
                    switch(entity.displayMode) {
                        case 4: // Push buttons
                            return false;
                        default:
                            return true;
                    }
                case 14:
                    switch(entity.displayMode) {
                        case 8: // Push buttons
                            return false;
                        default:
                            return true;
                    }
                case 19: // Quiz
                    return false;
                case 20: // Sort to groups
                    content = helpers.component.getContent(entity.componentsJSON, 'sortToGroups');

                    return (content.submit === false) ? false : true;
                default:
                    return true;
                }
            });

            self.showResetButton = ko.computed(function() {
                var entity = training.getEntity(entityVM.ID());

                return (entity.typeId === 15) ? true : false;
            });

// ------------- Validation -------------

            self.validate = function() {
                var ID = entityVM.ID();

                // if (feedback && self.canSubmitMultipleTimes() && !userAnswers.isTaskPageAnswered(ID)) {
                if (self.canSubmitMultipleTimes() && !userAnswers.isTaskPageAnswered(ID)) {
                    // feedback.close();
                    dialog.close({
                        type: 'feedback'
                    });
                }

                self.isValid(helpers.misc.validate(self));

                return true; // used for default behavious
            };

// ------------- END Validation -------------

            self.canSubmit = ko.computed(function() {
                return ( (!self.requiresAnswer() && (!self.enforceSequence() || entityVM.isQuizPage() || entityVM.isQuizGame()) || self.isValid()) && self.answersEnabled() ) ? true : false;
            });

// ------------- get Text By Content Entity ID  -------------

// can be moved to content helpers???
            self.getContentEntityNameByID = function(ID) {
                var entity = training.getEntity(ID);

                if (entity === null) {
                    return '';
                }

                return (entity.contentEntity.hasOwnProperty('name')) ? entity.contentEntity.name : '';
            };

            self.getContentEntityTextByID = function(ID) {
                var entity = training.getEntity(ID);

                if (entity === null) {
                    return '';
                }

                return (entity.contentEntity.hasOwnProperty('text')) ? entity.contentEntity.text : (entity.contentEntity.hasOwnProperty('content')) ? entity.contentEntity.content : '';
            };

// ------------- Custom texts  -------------

            self.customText = function(textID, index, contentEntityId) {
                return helpers.content.customText.getCustomText(self, textID, index, contentEntityId);
            };

            self.customCourseText = function(textID, index) {
                return helpers.content.customText.getCustomText(self.course, textID, index);
            };

// ----------- End custom texts  -----------


// ------------- Custom points  -------------

            self.setCustomPoints = function(points, overwrite) {

                if (!dataContext.offlinePackage && utils.onLine) {
                    return helpers.User.customPoints.setCustomPoints(self, points, overwrite);
                } else {
                    return;
                }
            };

// ----------- End custom points  -----------


// ------------- List top score learners  -------------

            self.getTopScoreLearners = function(take, cbFunc) {

                if (!dataContext.offlinePackage && utils.onLine) {
                    return helpers.User.customPoints.getTopScoreLearners(self, take, cbFunc);
                } else {
                    return;
                }
            };

// ------- End list top score learners ------

// ------------- Get current user score   -------------

            self.getCurrentUserScore = function(cbFunc) {

                if (!dataContext.offlinePackage && utils.onLine) {
                    return helpers.User.customPoints.getCurrentUserScore(self, cbFunc);
                } else {
                    return;
                }
            };

// ------- End get current user score ------

// ------------- Show custom modal   -------------

            self.showModal = function(modalData, btnMainFunc, btnSecondFunc) {
                var modalShown = false,
                    title,
                    body,
                    buttons = [],
                    btn1Text,
                    btn2Text;

                if(modalData) {
                    if (btnSecondFunc) {
                        btn2Text = (modalData.btnSecond) ? modalData.btnSecond : lang.cancel;
                    }
                    btn1Text = (modalData.btnMain) ? modalData.btnMain : lang.ok;

                    body = modalData.text;
                    title = modalData.header;

                    if (body) {
                        modal = new Modal({
                            content: body,
                            label: title,
                            enterClose: true,
                            showClose: false
                        });

                        buttons = [{
                            action: function () {
                                if (btnMainFunc) btnMainFunc()
                                modal.close();
                            },
                            class: 'bu bu-alt', text: btn1Text
                        }
                        ];
                        if (btn2Text) {
                            buttons.push({
                                action: function () {
                                    if (btnSecondFunc) btnSecondFunc()
                                    modal.close();
                                },
                                class: 'bu bu-alt', text: btn2Text
                            });
                        }
                        modal.addButtons(buttons);
                        modal.addClass("custom-modal");

                        modal.open();
                        modalShown = true;
                    }
                }
                return modalShown;
            };

            self.showCustomModal = function(index, btnMainFunc, btnSecondFunc) {
                var modalShown = false,
                    modalData,
                    component = self.getComponentsByKind('CustomModals');

                if(component.length > 0) {
                    modalData = component[0].content.items[index-1].content;
                    modalShown = self.showModal(modalData, btnMainFunc, btnSecondFunc);
                }
                return modalShown;
            };

            self.showCustomCourseModal = function(index, btnMainFunc, btnSecondFunc) {
                var modalShown = false,
                    modalData,
                    component = helpers.content.componentObject.getComponentsByKind(self.course, 'CustomModals');

                if(component.length > 0) {
                    modalData = component[0].content.items[index-1].content;
                    modalShown = self.showModal(modalData, btnMainFunc, btnSecondFunc);
                }
                return modalShown;
            };

// ------- End Show custom modal ------

            // used to set name attribute for radio/ checkbox in multichoice task
            self.getQuestionId = function() {
                var questions   = self.questions(),
                    questionId  = '';

                questions.forEach(function(el) {
                    questionId = el.id();
                });

                return questionId;
            };

            self.options = function(id) {
                var answers     = self.answers(),
                    arr         = [],
                    ID = '',
                    text = '';

                answers.forEach(function(el) {
                    if (id === el.questionId()) {
                        ID = el.id();
                        text = (userVM.hasRoles(['superadmin', 'coursehost']) || dataContext.debugMode) ? el.text() + (self.isAnswerCorrect(el.id()) ? '<span class="dk-hint">*</span>' : '') : el.text();

                        arr.push({'id': ID, 'text': text});
                    }
                });

                return arr;
            };

            ko.bindingHandlers.taskContent = {
                init: function() {
                    return {
                        controlsDescendantBindings: true
                    };
                },
                update:function(container, valueAccessor, allBindings, viewModel, bindingContext) {
                    var options = valueAccessor() || {},
                        parseQuestions = function(arr) {
                            var i = arr.length,
                                obj = {};

                            while(i--) {
                                obj['blank' + arr[i].orderNum] = arr[i].id;
                            }

                            return obj;
                        };

                    switch(options.typeID) {
                        case 18:
                            var contentHolder = document.createElement('div'),
                                dataQuestions = parseQuestions(self.computedQuestions());

                            contentHolder.innerHTML = self.contentText();

                            $('input', $(contentHolder)).each(function() {
                                var $item = $(this),
                                    itemID = $item.attr('id'),
                                    caption = $item.attr('defaultvalue') || $item.attr('value'),
                                    options = [],
                                    $select = null;

                                if (!caption || !dataQuestions[itemID]) {
                                    return;
                                }

                                options = self.options(dataQuestions[itemID]);

                                if (options.length) {
                                    $select = $('<select/>').attr({
                                        'id': dataQuestions[itemID],
                                        'name': dataQuestions[itemID],
                                        'class': 'js-select',
                                        'data-bind' :
                                        'options: $root.training.options("' + dataQuestions[itemID] + '"), ' +
                                        'optionsText: "text", ' +
                                        'optionsValue: "id", ' +
                                        'optionsCaption: "'+ caption +'", ' +
                                        'value: $root.training.getAnswerIdByQuestionId("' + dataQuestions[itemID] + '"), ' +
                                        'enable: $root.training.answersEnabled, ' +
                                        'css: $root.training.rowClass(\'f-row-fill-blanks\', $root.training.getAnswerIdByQuestionId("' + dataQuestions[itemID] + '") )'
                                    });
                                } else {
                                    $select = $('<select/>').attr({
                                        'class': 'js-select-disabled',
                                        'value': caption,
                                        'disabled': 'disabled',
                                        'data-bind' :
                                        'optionsCaption: "'+ caption +'", ' +
                                        'options: "'+ caption +'"'
                                    });
                                }

                                $item.after($select).remove();
                            });

                            container.innerHTML = contentHolder.innerHTML;
                            break;
                        default:
                            return false;
                    }

                    ko.applyBindingsToDescendants(bindingContext.createChildContext(bindingContext.$rawData), container);

                    if (utils.isFunction($.fn.dropkick)) {

                        $('.js-select-disabled').each(function() {
                            var $this = $(this);
                            try {
                                $this.dropkick();
                            } catch (e) {}
                        });

                        $('.js-select').each(function() {
                            var $this = $(this);
                            try {
                                $this.dropkick({
                                    change: self.validate
                                });
                            } catch (e) {}
                        });
                    }
                }
            };

            self.getArrPropByIndex = function(index, prop, arr) {
                var i   = parseInt(index, 10);
                return ( arr && arr.length > index && !!prop && arr[i].hasOwnProperty(prop) ) ? arr[i][prop] : '';
            };

// ------------- User Answers -------------

            self.isNotKnowOptionChecked = function(value) {
                return ( !self.answersEnabled() || self.showCorrectAnswers() || self.savedAnswers() === 'show' ) ? currentUserAnswer.isNotKnowOptionChecked(value) : false;
            };
            self.isAnswerValueEqual = function(value) {
                return ( !self.answersEnabled() || self.showCorrectAnswers() || self.savedAnswers() === 'show' ) ? currentUserAnswer.isAnswerValueEqual(value) : false;
            };
            self.getAnswerIdByQuestionId = function(id) {
                return ( !self.answersEnabled() || self.showCorrectAnswers() || self.savedAnswers() === 'show' ) ? currentUserAnswer.getAnswerIdByQuestionId(id) : '';
            };
            self.getAnswersIdByQuestionId = function(id) {
                return ( !self.answersEnabled() || self.showCorrectAnswers() || self.savedAnswers() === 'show' ) ? currentUserAnswer.getAnswersIdByQuestionId(id) : '';
            };
            self.getAnswerTextByQuestionId = function(id) {
                return ( !self.answersEnabled() || self.showCorrectAnswers() || self.savedAnswers() === 'show' ) ? currentUserAnswer.getAnswerTextByQuestionId(id) : '';
            };
            self.getAnswerTextByQuestionIdAlways = function(id) {
                return (self.savedAnswers() === 'hide') ? '' : currentUserAnswer.getAnswerTextByQuestionId(id);
            };
            self.getAnswerTextByAnswerId = function(id) {
                var answer = ( !self.answersEnabled() || self.showCorrectAnswers() || self.savedAnswers() === 'show' ) ? currentUserAnswer.getAnswerTextByAnswerId(id) : '';
                return answer;
            };
            self.getAnswerTextByAnswerIdAlways = function(id) {
                return (self.savedAnswers() === 'hide') ? '' : currentUserAnswer.getAnswerTextByAnswerId(id);
            };
            self.getQuestionIdByAnswerId = function(id) {
                return ( !self.answersEnabled() || self.showCorrectAnswers() || self.savedAnswers() === 'show' ) ? currentUserAnswer.getQuestionIdByAnswerId(id) : '';
            };
            self.getAnswerOrderNoByQuestionId = function(id) {
                var i = 0,
                    answers = null,
                    answerId = (training.state === 'reset' || training.state === 'reload') ? '' : self.getAnswerIdByQuestionId(id);

                if ( answerId ) {
                    answers = self.answers();
                    i = answers.length;
                    while(i--) {
                        if ( answerId === answers[i].id() ) {
                            return answers[i].orderNum();
                        }
                    }
                }
                return '';
            };

// ------------- END User Answers -------------

// ------------- Show (in)Correct Answers -------------

            self.colClass = function(type, parentID, ID, correct) {
                var colClass = [];

                if ( !self.answersEnabled() || self.showCorrectAnswers()) {
                    if (type === 'f-col-yes-no') {
                        colClass.push('f-col-' + self.answerStateYesNo(parentID, ID));
                    } else if (type === 'f-col-yes-no-boxes') {
                        colClass.push((self.getAnswerIdByQuestionId(parentID) === ID) ? 'f-col-button-' + self.answerStateYesNo(parentID, ID) + '-checked' : 'f-col-button-' + self.answerStateYesNo(parentID, ID));
                    } else if (type === 'f-col-match-pair') {
                        if (correct) {
                            colClass.push('f-col-correct');
                        } else {
                            colClass.push('f-col-' + self.questionState(ID));
                        }
                    }
                } else if (self.answersEnabled()) {
                    if (type === 'f-col-yes-no-boxes') {
                        colClass.push('f-col-active');
                    }

                    if (self.savedAnswers() === 'show') {
                        if (type === 'f-col-yes-no-boxes' && self.getAnswerIdByQuestionId(parentID) === ID) {
                            colClass.push('f-col-button-saved-checked');
                        }
                    }

                }

                if (userVM.hasRoles(['superadmin', 'coursehost']) || dataContext.debugMode) {

                    if (self.isYesNoAnswerCorrect(parentID, ID)) {
                        colClass.push('f-col-hint');
                    }
                }

                return colClass.join(' ');
            };

            self.rowClass = function(type, ID, status) {
                var rowClass = [];

                if (self.showCorrectAnswers() || !self.answersEnabled() && self.hasCorrectAnswers()) {
                    if (type === 'f-row-radio' || type === 'f-row-button') {
                        rowClass.push((ID === status) ? 'f-row-' + self.answerState(ID) + '-checked' : 'f-row-' + self.answerState(ID));
                    } else if (type === 'f-row-yes-no' || type === 'f-row-set-in-order') {
                        rowClass.push('f-row-' + self.questionState(ID) + '-checked');
                    } else if (type === 'f-row-yes-no-boxes') {
                        rowClass.push('box-inner-' + self.questionState(ID));
                    } else if (type === 'f-row-fill-blanks') {
                        rowClass.push('f-row-' + self.answerState(ID));
                    } else if (type === 'f-row-match-pair') {
                        rowClass.push('');
                    } else if (type === 'f-row-public') {
                        rowClass.push('');
                    } else if (type === 'f-row-sort') {
                        rowClass.push('f-row-' + self.sortToGroupsStatus(ID, status) + '-checked');
                    } else {
                        rowClass.push((status) ? 'f-row-' + self.answerState(ID) + '-checked' : 'f-row-' + self.answerState(ID));
                    }
                } else if (self.answersEnabled()) {

                    if (type !== 'f-row-yes-no-boxes') {
                        rowClass.push('f-row-active');
                    }

                    if (self.savedAnswers() === 'show') {
                        if (type === 'f-row-button') {
                            if (ID === status) {
                                rowClass.push('f-row-saved-checked');
                            }
                        } else if (type === 'f-row-yes-no-boxes') {
                            rowClass.push('box-inner-' + self.questionState(ID));
                        } else if (type === 'f-row-set-in-order') {
                            rowClass.push('f-row-set-in-order-alt');
                        }
                    }

                } else if (!self.answersEnabled()) {
                    if (type === 'f-row-button') {
                        rowClass.push((ID === status) ? 'f-row-answered-checked' : 'f-row-answered');
                    } else if (type === 'f-row-yes-no-boxes') {
                        rowClass.push('box-inner-answered');
                    } else {
                        rowClass.push('f-row-answered');
                    }
                }

                if (userVM.hasRoles(['superadmin', 'coursehost']) || dataContext.debugMode) {
                    if (self.isAnswerCorrect(ID)) {
                        rowClass.push('f-row-hint');
                    }
                }

                if (type === 'f-row-yes-no' && entityVM.containsStatistics() && self.isTaskAnswered() || !self.answersEnabled()) {
                    rowClass.push('f-row-social');
                }

                return rowClass.join(' ');
            };




            self.isQuestionCorrect = function(id) {
                var i               = 0,
                    j               = 0,
                    ID              = entityVM.ID(),
                    userAnswer      = userAnswers.getUserAnswer(ID),
                    uAnswers        = userAnswer.answers || [],
                    len             = uAnswers.length,
                    questions       = self.questions(),
                    questionsLen    = questions.length,
                    uAnswer         = '',
                    correctAnswer   = '';

                while(i < len) {
                    if (uAnswers[i].questionId === id ) {
                        uAnswer = uAnswers[i].answerId;
                        break;
                    }
                    i++;
                }

                while(j < questionsLen) {
                    if (questions[j].id() === id ) {
                        correctAnswer = questions[j].correctAnswerId();
                        break;
                    }
                    j++;
                }

                if (uAnswer === correctAnswer) {
                    return true;
                }

                return false;
            };

            self.isAnswerCorrect = function(id) {
                // Checks if user answered this correctly
                var i       = 0,
                    answers = self.answers(),
                    len     = answers.length;

                while (i < len) { // Multiplechoice & fill in blanks tasks
                    if (answers[i].id() === id && answers[i].points() > 0) {
                        return true;
                    }
                    i++;
                }
                return false;
            };

            self.isYesNoAnswerCorrect = function(id, value) {
                var question    = null,
                    questions   = self.questions(),
                    i           = questions.length;

                while(i--) {
                    question = questions[i];
                    if (question.id() === id && question.correctAnswerId() === value) {
                        return true;
                    }
                }
                return false;
            };

            self.questionState = function(questionID) {
                var ID = entityVM.ID();

                if ( self.hasCorrectAnswers() && ( !self.canSubmitMultipleTimes() || self.showCorrectAnswers() ) && userAnswers.isTaskPageAnswered(ID) ) {
                    return ( self.isQuestionCorrect(questionID) ) ? 'correct' : 'incorrect';
                } else if (userAnswers.isTaskPageAnswered(ID) && !self.showCorrectAnswers()) {
                    return 'answered';
                }
            };

            self.answerState = function(answerID) {
                var ID = entityVM.ID();

                if ( self.hasCorrectAnswers() && ( !self.canSubmitMultipleTimes() || self.showCorrectAnswers() ) && userAnswers.isTaskPageAnswered(ID) ) {
                    return ( self.isAnswerCorrect(answerID) ) ? 'correct' : 'incorrect';
                } else if (userAnswers.isTaskPageAnswered(ID) && !self.showCorrectAnswers()) {
                    return 'answered';
                }

                return '';
            };

            self.answerStateYesNo = function(answerID, value) {
                var ID = entityVM.ID();

                if ( self.hasCorrectAnswers() && ( !self.canSubmitMultipleTimes() || self.showCorrectAnswers() ) && userAnswers.isTaskPageAnswered(ID) ) {
                    return ( self.isYesNoAnswerCorrect(answerID, value) ) ? 'correct' : 'incorrect';
                } else if (userAnswers.isTaskPageAnswered(ID) && !self.showCorrectAnswers()) {
                    return 'answered';
                }

                return '';
            };

// ------------- END Show (in)Correct Answers -------------

// ------------- Action Buttons -------------

            $('#form').submit(function (e) {
                e.preventDefault();
            });

            self.resetForm = function(reload) {
                window.initPageRender = new Date();

                training.setState((reload === true) ? 'reload' : 'reset');

                entityVM.ID.valueHasMutated();
                self.validate();
            };

            self.buttonClick = function(obj) {
                if ( self.answersEnabled() ) {
                    self.isValid(true);
                    self.submitForm({name: self.getQuestionId(), value: obj.id});
                }

                return true;
            };

            self.forceSubmitForm = function() {
                self.isValid(true);
                self.submitForm();
            };

            self.submitForm = function(obj, e, arr) {
                var i                   = 0,
                    j                   = 0,
                    submittedAnswers    = $('#content').serializeArray(),
                    answers             = self.answers(),
                    answerId            = '',
                    answersLen          = answers.length,
                    questions           = self.questions(),
                    questionId          = '',
                    questionsLen        = questions.length,
                    raiseAlert          = false,
                    alertText           = lang.answerMissing;

                var ID = self.ID(),
                    parentID = self.parentId();

                arr = arr || [];

                if (obj) {
                    submittedAnswers.push(obj);
                }

                for (var a = 0; a < arr.length; a++) {
                    submittedAnswers.push(arr[a]);
                }

                if (self.typeId() === 13 && entityVM.displayMode() === 3) { // MultiChoice & checkbox

                    answers = self.answers();
                    var count = helpers.User.getMultipleChoiceSelectedOptionsCount(answers);

                    var comps = helpers.content.componentObject.getComponentsByKind(self, "CheckboxMinMax");
                    if(comps && comps.length > 0){
                        // there might be minAnswers & maxAnswers
                        var comp = comps[0],
                            min = comp.content.min,
                            max = comp.content.max;

                        if(min){
                            if(min > count) raiseAlert = true;
                        }
                        if(max){
                            if(max < count) raiseAlert = true;
                        }
                        if(raiseAlert) alertText = comp.content.alert;
                    }
                }

                if ( self.isValid() && !raiseAlert ) {
                    var checkbox = document.getElementById('is-public'),
                        isPublic = (checkbox && checkbox.checked) ? true : false;

                    userAnswers.logProgress(ID, {answers: []});

                    if ( self.typeId() === 16 && arr.length === 0 ) { // match pair task

                        while (i < answersLen) {
                            answerId = answers[i].id();

                            if (questionsLen) {
                                j = 0;
                                while (j < questionsLen) {
                                    questionId = questions[j].id();

                                    if ( $('#' + answerId).has('#' + questionId).length ) {

                                        userAnswers.addAnswer(ID, {
                                            answerId: answerId,
                                            answerText: '',
                                            questionId: questionId
                                        });
                                    }

                                    j++;
                                }
                            }

                            i++;
                        }

                    } else if ( self.typeId() === 20 ) { // sort to groups task

                        while(questionsLen--) {
                            questionId = questions[questionsLen].id();

                            $('#' + questionId).find('.js-sort-answer').each(function() {

                                answerId = $(this).attr('id');

                                userAnswers.addAnswer(ID, {
                                    answerId: answerId,
                                    answerText: '',
                                    questionId: questionId
                                });
                            });
                        }

                    } else if ( self.typeId() === 16 && arr.length ) {

                        submittedAnswers.forEach(function(answer) {
                            if (answer.value && answer.name) {
                                userAnswers.addAnswer(ID, {
                                    answerId: answer.value,
                                    answerText: '',
                                    questionId: answer.name,
                                    isPublic: isPublic
                                });
                            }
                        });

                    } else {
                        questions.forEach(function(question) {
                            var questionId = question.id();

                            submittedAnswers.forEach(function(answer) {

                                if ( !answer.hasOwnProperty('name') || !answer.hasOwnProperty('value') ) {
                                    return;
                                }

                                var answerName  = answer.name,
                                    answerValue = answer.value,
                                    freeText    = '';

                                if (!answerName && !answerValue) {
                                    return false;
                                }

                                if ( self.typeId() === 12 ) { // open question task
                                    freeText    = answerValue;
                                    answerValue = answerName;
                                }

                                if ( answerName === questionId || self.typeId() === 12 ) {
                                    if (questionId === answerValue) { // Evaluate task, I don't know option
                                        answerValue = null;
                                    }

                                    submittedAnswers.forEach(function(el) {
                                        if (el.name === questionId + '-free-text') {
                                            if ( el.value ) {
                                                freeText = el.value;
                                            }
                                        }
                                    });

                                    if ( self.typeId() === 15 ) { // set in order task

                                        i = 0;
                                        while (i < answersLen) {
                                            if ( parseInt( answer.value, 10) === answers[i].orderNum() ) {
                                                answerValue = answers[i].id();
                                                break;
                                            }
                                            i++;
                                        }
                                    }

                                    if (self.typeId() === 18) { // fill in blanks

                                        i = 0;
                                        j = 0;
                                        while (i < answersLen) {
                                            if (questionId === answers[i].questionId()) {
                                                j++;
                                                break;
                                            }
                                            i++;
                                        }

                                        if (j === 0) {
                                            //answerId = questionId;
                                            freeText = answerValue;
                                            answerValue = '';
                                        }
                                    }

                                    if ( self.typeId() === 17 ||  answerValue || freeText ) {   // evaluate

                                        userAnswers.addAnswer(ID, {
                                            answerId: answerValue,
                                            answerText: utils.escapeHTML(freeText),
                                            questionId: questionId,
                                            isPublic: isPublic
                                        });
                                    }

                                }

                            });

                        });

                    }

                    if ( self.isQuizTask() && self.isLastQuizTask(ID) ) {
                        var progress = userAnswers.getQuizPageProgress(parentID);

                        if (progress && progress.isAnswered && progress.isPassed) {
                            userAnswers.logVisited(parentID);
                            dataContext.logProgress('visited', parentID);
                        }

                        // Is this used ????
                        userAnswers.addAnswer(parentID, {
                            answered: true,
                            score: progress.userScore,
                            passed: progress.isPassed
                        });
                    }

                    var entity = training.getContent(ID);

                    if (training.scormPackage) {

                        if (helpers.entity.isTaskPage(entity)) {
                            userAnswers.logVisited(ID);
                            dataContext.logProgress('visited', ID);
                        }

                        require(['scormPackage'], function(ScormPackage) {
                            var scormPackage = new ScormPackage();

                            scormPackage.setSuspend(userAnswers);
                        });
                    }

                    dataContext.logProgress('answers', ID);

                    if (!entityVM.isQuizGame()) {

                        var navigateTo = userAnswers.getTargetID(ID),
                            noFeedbacks = !feedback.contains(entity), // (entity.feedbacks.filter(function(o) { return o.text }).length) ? false : true,
                            showFeedback = function(ID) {
                                self.answersEnabled(false);

                                openFeedback(ID);

                                if (entity.hasCorrectAnswers) {
                                    self.showCorrectAnswers(true);
                                }

                                viewModel.updateVM(ID);
                            };

                        if (navigateTo && noFeedbacks) {

                            if (entity.hasCorrectAnswers) {

                                self.answersEnabled(false);
                                self.showCorrectAnswers(true);

                                viewModel.updateVM(ID);

                                timeoutID = setTimeout(function() {
                                    self.goTo(navigateTo);
                                }, dataContext.forwardDelay);

                            } else {
                                self.goTo(navigateTo);
                            }

                        } else {

                            if (entity.naviTargetID && !entity.hasCorrectAnswers) {

                                if (noFeedbacks) {
                                    self.goTo(entity.naviTargetID);
                                } else {
                                    showFeedback(ID);
                                }

                            } else {
                                showFeedback(ID);
                            }

                        }

                    } // if not quiz game

                    if (entityVM.isTaskPage()) {
                        var taskSettings = helpers.component.getContent(entity.componentsJSON, 'TaskSettings'),
                            answerNotificationText = taskSettings.answerNotificationText,
                            closeIn = taskSettings.closeIn || 0;

                        if (answerNotificationText) {
                            dialog.open({
                                clone: true,
                                container: document.getElementById('notifications'),
                                content: answerNotificationText,
                                showClose: true,
                                overlay: false,
                                mainClass: 'modal modal-notification',
                                closeIn: closeIn * 1000
                            });
                        }
                    }

                    self.isTaskAnswered(true);

                } else {

                    modal = new Modal({
                        content: alertText,
                        enterClose: true,
                        showClose: false
                    });

                    modal.addButtons([
                        {action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok}
                    ]);

                    modal.open();
                }

                if (training.scormPackage) {

                    require(['scormPackage'], function(ScormPackage) {
                        var scormPackage = new ScormPackage();

                        if (entityVM.isTaskPage()) {
                            scormPackage.setTaskAnswer(self.getEntity(entityVM.ID()), userAnswers);
                        }

                        scormPackage.setLessonStatus(userAnswers);
                    });

                }

                // dataContext.sendProgress();
            };

// ------------- END Action Buttons -------------

            var getOrder = function() {
                var arr = [],
                    entity = training.getEntity(entityVM.ID());

                if (!entity) {
                    return;
                }

                entity.questions.forEach(function(question) {
                    var node = document.getElementById(question.id);

                    if (node && node.value) {
                        arr.push(parseInt(node.value));
                    }
                });

                for (var i = 1; i <= entity.questions.length; i++) {
                    if (arr.indexOf(i) === -1) {
                        return i;
                    }
                }

                return 1;
            };

            self.setInOrderOver = function(data) {
                var questionID = data.id,
                    input = document.getElementById(questionID),
                    row = (input) ? input.parentNode : null;

                if (!self.answersEnabled() || !row || input.value) {
                    return;
                }

                row.setAttribute('data-content', getOrder());
            }

            self.setInOrderOut = function(data) {
                var questionID = data.id,
                    input = document.getElementById(questionID),
                    row = (input) ? input.parentNode : null;

                if (!self.answersEnabled() || !row || input.value) {
                    return;
                }

                row.setAttribute('data-content', '');
            }

            self.setInOrder = function(data) {
                var questionID = data.id,
                    input = document.getElementById(questionID),
                    row = (input) ? input.parentNode : null,
                    cssClass = 'f-row-set-in-order-alt';

                if (!self.answersEnabled() || !row) {
                    return;
                }

                if (input.value) {
                    input.value = '';
                    row.classList.remove(cssClass)
                } else {
                    input.value = getOrder();
                    row.classList.add(cssClass)
                }

                row.setAttribute('data-content', '');

                self.validate();
            };

            self.sortToGroupsStatus = function(id, questionId) {
                var answers = entityVM.answersJS(),
                    answer = {},
                    i = answers.length;

                while(i--) {
                    answer = answers[i];
                    if ( answer.id === id ) {
                        return (answer.questionId === questionId) ? 'correct' : 'incorrect';
                    }
                }

                return '';
            };

            var sliderID = {};
            ko.bindingHandlers.initSlider = {      // For evaluate slider
                update: function(el, valueAccessor) {
                    var ID = entityVM.ID(),
                        questionID = ko.utils.unwrapObservable(valueAccessor()),
                        entity = training.getEntity(ID),
                        answers = entity.answers,
                        $slider = $(el),
                        disabled = (self.answersEnabled()) ? false : true,
                        value = (disabled) ? self.getAnswerOrderNoByQuestionId(questionID) : Math.ceil(answers.length/2);

                    if (!entity || entity.typeId !== 17 || entity.contentEntity.displayMode !== 6) {    //
                        return;
                    }

                    if (sliderID[questionID]) {
                        clearTimeout(sliderID[questionID]);
                    }

                    sliderID[questionID] = setTimeout(function() {

                        if (self.savedAnswers() === 'show') {
                            value = '';

                            (function() {
                                var i = 0,
                                    answers = null,
                                    answerId = self.getAnswerIdByQuestionId(questionID);

                                if ( answerId ) {
                                    answers = self.answers();
                                    i = answers.length;
                                    while(i--) {
                                        if ( answerId === answers[i].id() ) {
                                            value = answers[i].orderNum();
                                        }
                                    }
                                }
                            })();
                        }

                        $slider.noUiSlider({
                            range: {
                                'min': 1,
                                'max': answers.length
                            },
                            start: value,
                            step: 1,
                            handles: 1,
                            disabled: disabled
                        }, true);

                        $('.noUi-handle', $(el).closest('td')).text(value);

                        if (disabled) {
                            $slider.attr({'disabled': 'disabled'});
                        } else {
                            $(el).on({
                                change: function(){
                                    var index = parseInt($(this).val()),
                                        rule = function(obj) {
                                            return obj.orderNum === index;
                                        },
                                        answer = answers.filter(rule),
                                        val = answer[0].id;

                                    $('#' + questionID).val(val).prop({'checked': true});
                                    $('.noUi-handle', $(this).closest('td')).text(index);

                                    self.validate();
                                },
                                slide: function(){
                                    $('.noUi-target', $(this).closest('td')).addClass('slider-active');
                                }
                            });
                        }

                    }, 5);

                }
            };

            self.getUserAnswer = function(ID) {
                ID = ID || entityVM.ID();
                return new CurrentUserAnswer(user.answers, ID);
            };

// ------------- Main Pagination -------------

            self.showQuizFeedback = ko.observable(false);

            self.isLastQuizTask = function(ID) {
                var entity = null,
                    computedQuizMap = self.quizMap().slice(0),
                    index = computedQuizMap.indexOf(ID),
                    len = computedQuizMap.length;

                if (index === len - 1) {
                    return true;
                }

                index++;

                for ( ; index < len; index++) {
                    entity = training.getEntity(computedQuizMap[index]);

                    if (entity && entity.typeId !== 10) {
                        return false;
                    }
                }

                return true;
            };

            self.quizMapById = function(ID) {
                var obj = null,
                    entity = null,
                    answers = user.answers,
                    i = answers.length;

                while(i--) {
                    if ( answers[i].contentEntityId === ID ) {
                        obj = answers[i];
                        break;
                    }
                }

                if (obj && obj.computedQuizMap) {
                    return obj.computedQuizMap.slice(0);
                } else {

                    entity = training.getEntity(ID);
                    if (entity !== null) {
                        return helpers.content.getQuizMap(entity.children);
                    }
                }

                return [];
            };

            self.showQuizProgress = function() {
                return ( self.isQuizTask() || self.isQuizPage() && self.showQuizFeedback() ) ? true : false;
            };

            self.getQuizProperty = function(prop) {
                var ID          = entityVM.ID(),
                    entity      = null,
                    quizId      = '',
                    getQuizId   = function(ID) {
                        var entity = training.getEntity(ID);

                        if (entity !== null) {
                            if ( entity.typeId === 19) {
                                return entity.contentEntityId;
                            } else if ( entity.contentEntity.parentId !== self.contentContainerID() ) {
                                return getQuizId(entity.contentEntity.parentId);
                            } else {
                                return '';
                            }
                        }

                    };

                if ( self.isQuizPage() ) {
                    entity = training.getEntity(ID);
                } else if ( self.isQuizTask() ) {
                    quizId = getQuizId(ID);
                    if (quizId) {
                        entity = training.getEntity(getQuizId(ID));
                    }
                }

                if (entity !== null) {

                    if (entity.hasOwnProperty(prop)) {
                        return entity[prop];
                    } else if ( entity.contentEntity.hasOwnProperty(prop) ) {
                        return entity.contentEntity[prop];
                    } else {
                        return null;
                    }
                }

                return null;
            };

            self.quizPagination = ko.computed(function() {
                var id          = entityVM.ID(),
                    map         = self.quizMap(),
                    paging      = null;

                if ( map && map.length ) {
                    paging = new Pagination(map, id, viewModel);
                }

                if (!self.quizPage) {
                    self.quizPage       = ko.observable();
                    self.quizTotal      = ko.observable();
                    self.quizPrevDisabled = ko.observable(false);
                    self.quizNextDisabled = ko.observable();
                }

                if ( paging ) {
                    self.quizPage(paging.page);
                    self.quizTotal(paging.total);

                    // Get Quiz Page obj & prop

                    if ( !self.getQuizProperty('canSubmitMultipleTimes') ) {
                        self.quizPrevDisabled(true);
                    } else {
                        self.quizPrevDisabled(false);
                    }

                    if ( self.getQuizProperty('enableMovingBackwards') ) {
                        self.quizPrevDisabled(paging.prevDisabled);
                    }

                    self.quizNextDisabled(paging.nextDisabled);
                } else {
                    self.quizPage(0);
                    self.quizTotal(0);
                    self.quizPrevDisabled(true);
                    self.quizNextDisabled(true);
                }

                self.quizRestart = function() {

                    self.quizRestarting(true);

                    if ( self.isQuizPage() ) {
                        // self.quizReset();
                        self.quizResetById(entityVM.ID());
                        self.goToQuizPage(1);
                    } else {
                        self.goTo( self.parentId() );
                    }
                };

                // TODO: remove, unused
                self.quizReset = function() {
                    return self.quizResetById(entityVM.ID());
                };

                self.quizResetById = function(ID) {
                    userAnswers.resetQuizAnswers(ID);
                    dataContext.logProgress('sync', ID);
                };

                self.quizPrev = function(swiping) {
                    if (self.quizPrevDisabled()) {
                        return;
                    }

                    if (!!self.getQuizProperty('enableMovingBackwards') && paging ) {
                        self.goTo(null, swiping, 'Back');
                    } else if (self.getQuizProperty('canSubmitMultipleTimes')) {
                        self.goTo(self.parentId(), swiping);
                    }

                };

                self.quizNext = function(swiping) {
                    if (self.quizNextDisabled()) {
                        return;
                    }

                    if (paging) {
                        self.goTo(null, swiping, 'Forward');
                    }
                };

                self.goToQuizFeedback = function(swiping) {

                    self.quizRestarting(false);
                    self.goTo(self.parentId(), swiping, 'Parent');
                };

                self.goToQuizPage = function(target) {

                    window.initPageRender = new Date();

                    var i       = 0,
                        id      = entityVM.ID(),
                        answers = user.answers,
                        len     = answers.length;

                    if ( self.typeId() === 19 && paging ) {
                        paging.goTo(target);
                    } else {
                        while(i<len) {
                            if (answers[i].contentEntityId === id) {
                                if (answers[i].answers && answers[i].answers.length && paging) {
                                    self.resetForm();
                                    paging.goTo(target);
                                }
                            }
                            i++;
                        }
                    }
                };
            });

            self.isTaskCorrect = function(ID) {
                return userAnswers.isTaskCorrect(ID);
            };

            self.quizProgress = ko.computed(function() {
                var isTaskAnswered = self.isTaskAnswered(),
                    ID = (entityVM.isQuizTask()) ? entityVM.parentId() : entityVM.ID(),
                    index = -1,
                    progress = userAnswers.getQuizPageProgress(ID),
                    arr = [];

                if (progress) {
                    arr = progress.progress.slice(0);

                    if (entityVM.isQuizTask()) {
                        index = progress.childrenID.indexOf(entityVM.ID());
                    }
                }

                if (index > -1 && arr.length > index && arr[index] !== 'correct' && arr[index] !== 'incorrect') {
                    arr[index] = 'current';
                }

                return arr;
            }).extend({rateLimit: 0});

            self.quizCorrectTasks = ko.computed(function() {
                var progress = userAnswers.getQuizPageProgress(entityVM.ID()) || {},
                    correct = progress.correct || [],
                    total = 0;

                if (!correct.length) {
                    return total;
                }

                for (var i = 0; i < correct.length; i++) {
                    if (correct[i]) {
                        total++;
                    }
                }

                return total;
            });

            self.lastQuizProgress = function() {
                var lastQuiz = helpers.content.getLastQuiz(self.trainingMap().slice(0), self.trainingContentEntities().slice(0)),
                    progress = userAnswers.getQuizPageProgress(lastQuiz.ID);

                return {
                    correctTasks: _.filter(progress.correct, function(item) { return item === true;}).length,
                    totalTasks: progress.correct.length,
                    isAnswered: progress.isAnswered,
                    isPassed: progress.isPassed
                }
            };

            self.customQuizFeedback = function(progress) {
                var content = helpers.component.getContent(entityVM.componentsJSON(), 'Feedbacks'),
                    arr = helpers.component.parseProp(content, 'feedbacks', 'FeedbackText'),
                    min = 0,
                    score = -1,
                    feedback = '';

                for (var i = 0; i < arr.length; i++) {
                    min = parseFloat(arr[i].score);

                    if (min <= progress.userScore && min > score) {
                        feedback = arr[i].feedback;
                        score = min;
                    }
                }

                return {
                    content: feedback
                }
            };

            self.quizContentText = ko.computed(function() {
                var progress,
                    feedback,
                    customFeedback;

                if (self.isQuizPage() ) {
                    progress = userAnswers.getQuizPageProgress(entityVM.ID());

                    if (progress && progress.isAnswered || entityVM.isQuizGame()) {
                        self.showQuizFeedback(true);    // This should be deprecated at some point
                        training.showQuizFeedback = true;

                        customFeedback = self.customQuizFeedback(progress);

                        if (customFeedback.content) {
                            feedback = customFeedback.content;
                        } else {

                            if (entityVM.passAlways()) {
                                feedback = self.passedFeedback();
                            } else {
                                feedback = (progress.userScore >= entityVM.passThreshold()) ? self.passedFeedback() : self.failedFeedback();
                            }
                        }

                        if (feedback) {
                            feedback = helpers.misc.replaceTextholder(viewModel, data, feedback);
                        }

                        return feedback;

                    } else {
                        self.showQuizFeedback(false);    // This should be deprecated at some point
                        training.showQuizFeedback = false;

                        var skipComp = self.getComponentsByKind("SkipQuizStart")[0]; // return an array
                        var skipStart = (skipComp != undefined);
                        if(skipStart){
                            if (dataContext.debugMode) {
                                console.log(" - - - SkipQuizStart");
                            }
                            self.goToQuizPage(1);
                        }
                    }
                }

                return self.contentText();
            }).extend({rateLimit: 0});

            ko.computed(function () {
                var ID = entityVM.ID(),
                    entity = training.getContent(ID),
                    game = null,
                    paging = null;

                if (entityVM.isQuizGame()) {
                    game = helpers.content.getQuizGame(ID, data.training.contentEntities);
                    ID = (game && game.ID) ? game.ID : ID;
                } else if (entityVM.isQuizTask()) {
                    ID = entityVM.parentId();
                }

                paging = new Pagination(self.trainingMap(), ID, viewModel);

                if (!self.page) {

                    self.page = ko.observable();
                    self.progress = ko.observable();
                    self.prevDisabled = ko.observable();
                    self.nextDisabled = ko.observable();

                    self.total = ko.observable(paging.total);
                }

                self.goTo = function (target, swiping, direction, initPageRender) {
                    var ID = entityVM.ID(),
                        targetID = '',
                        status;

                    if (modal && modal.isVisible()) {
                        return;
                    }

                    window.initPageRender = initPageRender || new Date();

                    if (target && (target === 'Back' || target === 'Forward')) {
                        direction = target;
                        target = null;
                    }

                    targetID = navigation.getTargetID(ID, target, direction);

                    status = navigation.validate({
                        ID: ID,
                        targetID: targetID,
                        direction: direction
                    });

                    if (!status.canContinue) {

                        var mContent = '',
                            mButtons = [],
                            enterClose = true,
                            showClose = false;

                        if (status.type === 'current' || status.type === 'previous') {

                            if (status.type === 'previous') {
                                mContent += lang.missedOne + ' ';
                            }

                            switch(status.reason) {
                                case 'quiz-progress-reset':
                                    mContent += lang.quizRestart;
                                    mButtons.push({action: function() {
                                        // self.quizReset();
                                        self.quizResetById(self.parentId());
                                        modal.close();
                                        self.goTo( self.parentId() );
                                    }, class: 'bu bu-alt', text: lang.restart});
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.cancel});
                                    break;
                                case 'quiz-game-page-not-passed':
                                    mContent += lang.quizGamePassRequired;
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                    break;
                                case 'quiz-page-not-answered':
                                    mContent += lang.quizAnswerRequired;
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                    break;
                                case 'quiz-page-in-progress':
                                    mContent += lang.quizAnswerRequired;
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                    break;
                                case 'quiz-page-not-passed':
                                    mContent += lang.quizPassRequired;
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                    break;
                                case 'task-page-not-answered':
                                    mContent += lang.answerRequired;
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                    break;
                                case 'content-page-not-visited':
                                    mContent += (status.reason === 'content-page-not-visited') ? lang.requiredVisit : lang.requiredTask;
                                    mContent = mContent.replace('{target.name}', status.target.title).replace('{required.name}', status.missing.title);
                                    break;
                                case 'page-missing-interaction':
                                    mContent += lang.missingInteraction;
                                    mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                    break;
                                default:
                                // mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.ok});
                                // mButtons.push({action: function() {
                                //     self.quizReset();
                                //     self.goTo( self.parentId() );
                                //     modal.close(); }, class: 'bu bu-alt', text: lang.restart});
                                // mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.cancel});
                            }

                            if (status.type === 'previous') {
                                mButtons = [];
                                mButtons.push({action: function () {modal.close(); paging.goTo(status.missing.ID); }, class: 'bu bu-alt', text: lang.return});
                                mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.cancel});
                            }

                        } else {

                            mContent += (status.reason === 'content-page-not-visited') ? lang.requiredVisit : lang.requiredTask;
                            mContent = mContent.replace('{target.name}', status.target.title).replace('{required.name}', status.missing.title);

                            enterClose = false;

                            mButtons.push({action: function () {modal.close(); paging.goTo(status.missing.ID); }, class: 'bu bu-alt', text: lang.proceed});
                            mButtons.push({action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.cancel});
                        }

                        if (dataContext.debugMode && dataContext.previewMode) {
                            console.warn('Can NOT continue: ' + mContent);
                            console.dir(status);
                        }

                        if (dataContext.debugMode) {
                            mContent += '<br>';
                            mContent += '<br>type: ' + status.type;
                            mContent += '<br>status: ' + status.reason;
                        }

                        if (!dataContext.debugMode || !dataContext.previewMode) {

                            mContent = mContent || ' ';

                            modal = new Modal({
                                content: mContent,
                                enterClose: enterClose,
                                showClose: showClose
                            });

                            if (mButtons.length) {
                                modal.addButtons(mButtons);
                            }

                            modal.open();
                        }
                    }

                    if (status.canContinue || dataContext.debugMode && dataContext.previewMode) {
                        navigation.navigateTo(targetID, swiping, direction);
                    }
                };

                self.next = function (swiping) {
                    if (self.nextDisabled() && training.modularMenuPageID === null) {
                        return;
                    }

                    self.goTo(null, swiping, 'Forward');
                };

                /**
                 * Used for alternative navigation that happens inside a page for example changing slide show.
                 * Activated by self.alternativeNavigation(true)
                 * @param {Boolean} swiping - True when navigation by swipe gesture
                 */
                self.nextAlt = function (swiping) {
                    console.log("ALT NEXT navi NOT overridden!");
                    self.next(swiping);
                };

                self.prev = function (swiping) {
                    var target = 'Back';

                    if (self.prevDisabled()) {
                        return;
                    }

                    // self.resetForm();

                    var isLevel1 = helpers.navigation.isLevel1(entityVM.ID(), data.training.contentEntities);

                    if (training.modularMenuPageID !== null && isLevel1){
                        target = training.modularMenuPageID;
                    }

                    self.goTo(target, swiping);
                };

                /**
                 * Used for alternative navigation that happens inside a page for example changing slide show.
                 * Activated by self.alternativeNavigation(true)
                 * @param {Boolean} swiping - True when navigation by swipe gesture
                 */
                self.prevAlt = function (swiping) {
                    console.log("ALT PREV navi NOT overridden!");
                    self.prev(swiping);
                };

                if (entity.typeID === 19 && !paging.nextDisabled) {
                    var progress = userAnswers.getQuizPageProgress(ID);

                    if (entity.requiresCompletion && progress && !progress.isPassed && !progress.isVisited) {
                        paging.nextDisabled = true;
                    }
                }

                self.page(paging.page);
                self.progress(paging.progress);
                self.prevDisabled(paging.prevDisabled);
                self.nextDisabled(paging.nextDisabled);
            });

            self.pageIndex = function() {
                var ID = entityVM.ID(),
                    game = null,
                    trainingMap = self.trainingMap(),
                    index = 0;

                if (entityVM.isQuizGame()) {
                    game = helpers.content.getQuizGame(ID, data.training.contentEntities);
                    ID = (game && game.ID) ? game.ID : ID;
                } else if (entityVM.isQuizTask()) {
                    ID = entityVM.parentId();
                }

                index = trainingMap.indexOf(ID) + 1;

                return index + '/' + self.total();
            };

            self.navigateTo = function(id){
                if ( id === 'next' ) {
                    if ( self.isQuizTask() ) {
                        self.quizNext();
                    } else {
                        self.next();
                    }
                } else if ( id === 'prev' ) {
                    if ( self.isQuizTask() ) {
                        self.quizPrev();
                    } else {
                        self.prev();
                    }
                } else {
                    self.goTo( id );
                }
            };

            $(function() {

                var $body = $('body');

                $body.on('click', '.goto', function(e) {
                    var id = $(this).data('id');
                    e.preventDefault();

                    $body.removeClass('nav-menu-open');
                    self.navigateTo(id);
                });

                $body.on('click', '[linktypeid="2"]', function(e) {
                    var id = $(this).attr('linkentityid');
                    e.preventDefault();
                    self.navigateTo( id );
                });

                $body.on('click', '.js-f-label-star', function() {
                    if ( $(this).children('input').prop('disabled') ) {
                        return false;
                    }

                    $(this).siblings().removeClass('f-label-checked').end()
                        .parent('.js-f-col-star').addClass('f-col-chosen').end()
                        .addClass('f-label-checked');
                });

                $body.on('click', '.js-f-col-unknown .f-input', function() {
                    var $row = $(this).closest('tr');

                    if ( !$(this).prev('input').prop('disabled') ) {
                        $row.find('.f-label-star').removeClass('f-label-checked');
                        $row.find('.js-f-col-star').removeClass('f-col-chosen');
                    }
                });

                $('body').on('click', '.hide-box', function(e) {
                    e.preventDefault();
                    $(this).closest('.box').removeClass('open');
                });

                $(document).on('click', '.js-close-player', function(e) {
                    e.preventDefault();

                    modal = new Modal({
                        content: lang.closePlayer
                    });

                    modal.addButtons([
                        {action: function() { window.close(); }, class: 'bu bu-alt', text: lang.yes}
                    ]);

                    modal.open();
                });

                $(document).on('click', '.js-toggle-nav-menu', function(e) {
                    var top = 0,
                        nav = document.getElementById('nav-info'),
                        current;

                    e.preventDefault();


                    if(viewModel.modularNavigation.hideToc() && training.modularMenuPageID !== null) {
                        self.naviTargetId(training.modularMenuPageID);
                        self.goTo(entityVM.naviTargetId());

                    } else {
                        dialog.close({
                            type: 'dialog'
                        });

                        document.body.classList.toggle('nav-menu-open');

                        if (nav) {
                            current = nav.querySelector('.nav-current');
                            if (current) {
                                current.classList.remove('nav-current');
                            }
                        }

                        setTimeout(function() {
                            top = ($('.nav-current').length) ? $('.nav-current').offset().top - 80 : 0;
                            $('.js-nav').animate({scrollTop: top}, 0);
                        }, 0);
                    }
                });

                $(document).on('click', '.js-open-comment-tool', function(e) {
                    var ctopen = commentTool.open();
                    e.preventDefault();
                    if( ctopen !== 'ok' ){

                        modal = new Modal({
                            content: lang.commentToolError.replace('{ctopen}', ctopen),
                            showClose: false
                        });

                        modal.addButtons([
                            {action: function() { modal.close(); }, class: 'bu bu-alt', text: lang.close}
                        ]);

                        modal.open();
                    }
                });

            });

            var toggleTextarea = function() {
                var box = document.querySelector('.js-textarea-box');

                if (!box) {
                    return;
                }

                var parent = box.parentNode,
                    readonly = !box.checked,
                    texterea = parent.querySelector('.js-textarea');

                if (!texterea) {
                    return;
                }

                texterea.readOnly = readonly;
            }

            document.body.addEventListener('change', function(e) {
                var target = e.target;

                if (target.classList.contains('js-toggle-textarea')) {
                    toggleTextarea()
                }
            });

            // Key bindings for navigation with keyboard arrows
            $(document).keydown(function(e){
                if(self.allowKeyboardShorts() && !(entityVM.isQuizGame() && (entityVM.isQuizPage() || entityVM.isQuizTask()))) {
                    var tag = e.target.tagName.toLowerCase();
                    if (tag !== 'input' && tag !== 'textarea') {
                        switch (e.which) {
                            case 8:     // backspace
                                if (!self.isQuizTask()) {
                                    self.prev();
                                }
                                break;
                            case 27:    // escape
                                // hideFeedback(); // hide boxes
                                break;
                            case 37:    // left arrow
                                if (self.isQuizTask()) {
                                    self.quizPrev();
                                } else {
                                    self.prev();
                                }
                                break;
                            case 39:    // right arrow
                                if (self.isQuizTask()) {

                                    if (self.quizNextDisabled()) {
                                        self.goToQuizFeedback();
                                    } else {
                                        self.quizNext();
                                    }
                                } else {
                                    self.next();
                                }
                                break;
                            default:
                                return;
                        }
                        e.preventDefault();
                    }
                }
            });

// ------------- END Main Pagination -------------

            commentTool.init($, self);

            if (dataContext.svgsInIndexHtml == true) {
                $(document).ready(function() {
                    var $offlineSVGEls = $('div#embedded-svgs svg');

                    window.offlineSVGs = {};

                    $offlineSVGEls.each(function(index){
                        var svg = $offlineSVGEls[index],
                            svgName = svg.getAttribute('data-file-name')

                        if (svgName) {
                            window.offlineSVGs[svgName] = svg.outerHTML || $('<div>').append($(svg).clone()).html();
                        }

                        $(svg).remove();
                    });
                });
            }

            self.setNaviTargetId = function(){
                var targetId,
                    isSectionLastPage = helpers.navigation.isSectionLastPage(entityVM.ID(), data.training.contentEntities);

                if(training.modularMenuPageID !== null && (isSectionLastPage || self.showQuizFeedback())){
                    targetId = training.modularMenuPageID === null;
                }else{
                    targetId = self.defaultNaviTargetId();
                }
                self.naviTargetId(targetId);
            };

            ko.computed(function() {
                self.setNaviTargetId();
                commentTool.changed($, self);
            });


        };

    });

